<ion-item
  [lines]="lines"
  [detail]="isButton"
  [button]="isButton"
  [disabled]="isDisabled"
>

  @if (showImage || icon || iconTitle) {
    <ion-thumbnail slot="start">

      @if (showImage) {
        <img [src]="image || 'assets/img/empty-img/no_image.png'" alt=""/>

      } @else if (icon) {
        <yu-icon [name]="icon" [color]="colorIcon"></yu-icon>
      }

      @if (iconTitle) {
        <div class="icon-title-wrapper icon-background" [ngClass]="[backgroundIconTitle]">
          <yu-icon color="light" [name]="iconTitle"></yu-icon>
        </div>
      }

      @if (ranking) {
        <div class="ranking-badge" [ngClass]="{'gold': ranking === 1, 'silver': ranking === 2, 'bronze': ranking === 3}">
          {{ ranking }}
        </div>
      }

    </ion-thumbnail>
  }

  <ng-content select="[extra-thumbnail]"></ng-content>

  <ion-label (click)="clickItem.emit()">

    <p class="title">{{ title }}</p>

    @if (description) {
      <p class="description">{{ description }}</p>
    }

    <ng-content select="[content-label]"></ng-content>

  </ion-label>

  @if (state || (cost || cost === 0) || (quantity || quantity === 0) || (extraData || extraData === 0)) {
    <ion-note slot="end" [ngClass]="{'button-item': isButton}">

      @if (state && colorState) {
        <yu-tag [color]="colorState">{{ state }}</yu-tag>
      }

      @if ((cost || cost === 0) && permissionsManager.checkPermission('precios', 'ver')) {
        <p>{{ cost | currency: 'EUR' : 'symbol' : '1.2-2' : 'es' }}</p>
      }

      @if (quantity || quantity === 0) {
        <p>{{ quantity | number : '1.0-2' }} {{ unit || '' }}</p>
      }

      @if (extraData || extraData === 0) {
        <p>{{ extraData }}</p>
      }

    </ion-note>
  }

  <ng-content select="[extra-note]"></ng-content>

</ion-item>
